import * as React from 'react';

import { FormResponseError } from '../../components/cirium/FormResponseError';
import { CiriumCard } from '../../components/cards/CiriumCard';
import { HoneypotInput } from '../../components/forms/HoneypotInput';
import styles from './travelerLoginCard.module.css';

import {
  Box,
  Button,
  Flex,
  Form,
  Link,
  PasswordField,
  TextField,
  TextInput,
  ToastConsumer,
} from '@flightstats/airframe-react';

interface TravelerLoginFormValues {
  username: string;
  password: string;
  kwijybo: string;
}

interface FormErrors {
  [key: string]: string;
}

interface AddToast {
  (message: string, options?: { appearance: 'success' | 'error' | 'info' | 'warning' }): void;
}

interface TravelerLoginCardProps {
  handleLogin: (errors: FormErrors, values: TravelerLoginFormValues, addToast: AddToast) => void;
  loading: boolean;
  showError: boolean;
  brandingImageUrl?: string | null;
}

export const TravelerLoginCard: React.FC<TravelerLoginCardProps> = ({
  handleLogin,
  loading,
  showError,
  brandingImageUrl,
}) => {
  return (
    <ToastConsumer>
      {({ addToast }) => (
        <CiriumCard
          brandingImageUrl={brandingImageUrl}
          title="Welcome"
          description="Log into Trip Alert with the user information entered during the registration process"
        >
          <Form
            onSubmit={(errors : FormErrors, values : TravelerLoginFormValues, e : any) => {
              e.event.preventDefault(); // Needed for submitOnEnter
              handleLogin(errors, values, addToast);
            }}
            submitOnEnter
          >
            {showError && (
              <FormResponseError message="Wrong username or password" />
            )}
            <TextField required>
              
                <TextInput
                  autoFocus
                  id="username"
                  label="Username"
                  placeholder="Enter your username"
                  disabled={loading}
                />
              
            </TextField>

            <PasswordField
              required
              validate={() => {
                true;
              }}
            >
              
                <TextInput
                  id="password"
                  label="Password"
                  placeholder="Enter your password"
                  type="password"
                  disabled={loading}
                />
              
            </PasswordField>

            <HoneypotInput />

            <Box className={styles.paddingBottom}>
              <Link href={loading ? '' : '/traveler/forgot'}>Forgot Login</Link>
            </Box>

            <Flex className={styles.flexColumnCenter}>
              <Button type="submit" disabled={loading}>
                LOG IN
              </Button>
            </Flex>
          </Form>
        </CiriumCard>
      )}
    </ToastConsumer>
  );
};